<template>
  <div>
    <label
      v-if="label"
      :for="forAttr"
      class="m-0 p-0 font-medium text-grey-40"
      :class="disabled ? 'opacity-75' : ''"
      :style="labelStyle">
      {{ label }}
      <span
        v-if="optional"
        class="text-xs font-lighter italic">
        {{ $t('common.formFields.fields.optional') }}
      </span>
    </label>
    <slot name="hint" />
    <div :class="disabled ? 'opacity-75' : ''">
      <slot />
    </div>
    <div
      v-if="errorMessage"
      class="mt-1 text-sm text-danger"
      :style="errorStyle">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import FieldMixin from '@common/components/mixins/FieldMixin'

export default {
  mixins: [FieldMixin]
}
</script>
